var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMengenrabattBadgeSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#fc0000"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 19.037109,
    y: 16.912109,
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: "8px",
    fontWeight: "bold",
    stroke: "#ffffff",
    strokeWidth: 0.4,
    "text-align": "center",
    textAnchor: "middle",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19.037109,
    y: 16.912109
  }, "MENGEN"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.037109,
    y: 26.912109
  }, "RABATT"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMengenrabattBadgeSm);
export default __webpack_public_path__ + "static/media/mengenrabatt-badge-sm.2c16a5248e8a8bcf5ccf55f602dfea04.svg";
export { ForwardRef as ReactComponent };